// German for FlowMatrix.tsx. Keys already carried by `i18n/common.de.ts` and `NetworkZone.de.ts`
// (held by rule, estimated, held, proposed …) are not repeated here.
import { registerDe } from '../../i18n/index.js';

registerDe({
  'No provider names a payer under these filters, so there is no matrix to draw.':
    'Unter diesen Filtern nennt keine Organisation einen Kostenträger — es gibt keine Matrix zu zeichnen.',
  'rev.': 'Ertr.',
  'pl.': 'Pl.',
  'Provider': 'Anbieter',
  'the Σ of this provider’s mix — computed, carries no mark': 'die Σ des Mix dieses Anbieters — berechnet, ohne Anspruchszeichen',
  'attributed': 'zugeordnet',
  'people': 'Personen',
  'proposed, not held': 'vorgeschlagen, nicht übernommen',
  '{n} rows on this pair': '{n} Zeilen zu diesem Paar',
  'Σ of the {basis} mix, {year}': 'Σ des Mix «{basis}», {year}',
  'providers naming it': 'Anbieter, die ihn nennen',
}, 'FlowMatrix');
